import { Udm, UnidAnchoBanda } from "../../../isp.žapi.planes/constantesApiPlanes";


const EstadosPlanLabel = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};


// const TipoPlanLabel = {};
// TipoPlanLabel[TipoPlan.PlanInternet] = "Plan.Int.";
// TipoPlanLabel[TipoPlan.ServiciosGen] = "Serv. Gen.";
// TipoPlanLabel[TipoPlan.Articulo] = "Articulo";
    
const UnidadPlanLabel = {}
UnidadPlanLabel[Udm.Mensual] = "Mensual";
UnidadPlanLabel[Udm.Unidad] = "Unid.";

const UnidadAnchoBandaLabel = {}
UnidadAnchoBandaLabel[UnidAnchoBanda.Megas] = "Mbps";
UnidadAnchoBandaLabel[UnidAnchoBanda.Gigas] = "Gbps";

export {UnidadAnchoBandaLabel, UnidadPlanLabel, EstadosPlanLabel};
